<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.13477 1.47168C7.52001 0.806795 8.47999 0.806795 8.86523 1.47168L15.833 13.498C16.2193 14.1647 15.7383 14.999 14.9678 14.999H1.03223C0.26174 14.999 -0.219281 14.1647 0.166992 13.498L7.13477 1.47168Z"
            fill="#FFBB16"
        />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 10H7L7 5H9V10Z" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 13H7V11H9V13V13Z" fill="white" />
    </svg>
</template>
